import type { IconData } from '@stacksjs/iconify-core'

export const pottedFlowerSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 1.794a7.36 7.36 0 0 0-6.876 4.742a7.356 7.356 0 0 0-4.25 13.08A7.356 7.356 0 0 0 22.5 28.45v5.052c-4.469.007-7.447.046-9.144.078c-1.218.022-2.622.635-2.807 2.11q-.048.367-.05.81c-.001.443.019.566.05.81c.165 1.316 1.3 1.946 2.408 2.083c.19.922.444 2.086.726 3.222c.573 2.308 2.573 3.781 4.916 3.834c1.3.03 3.055.051 5.4.051c2.347 0 4.1-.021 5.401-.05c2.344-.054 4.344-1.527 4.917-3.835c.282-1.136.535-2.3.725-3.222c1.108-.137 2.244-.767 2.409-2.082a6.7 6.7 0 0 0-.001-1.621c-.184-1.475-1.588-2.088-2.806-2.11a544 544 0 0 0-9.144-.078V28.45a7.356 7.356 0 0 0 9.626-8.835a7.356 7.356 0 0 0-4.25-13.079A7.36 7.36 0 0 0 24 1.794M24 20.5a4.5 4.5 0 1 1 0-9a4.5 4.5 0 0 1 0 9\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default pottedFlowerSolid
